import { useState } from "react";
import {
    EditarInformacaoController,
    getInfoOrganizacaoServiceController,
} from "../../../Controllers/Geral/InformacaoOrganizacao/InformacoesOrganizacaoControllers";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import InfoNavBar from "./InfoNavBar";
import Tab from "react-bootstrap/Tab";
import OrSpinner from "../../../Components/Utils/OrSpinner";
import NotFound from "../../Errors/NotFound";
import InfoGeral from "./InfoGeral";
import InfoEndereco from "./InfoEndereco";
import InfoEmail from "./InfoEmail";
import InfoERP from "./InfoERP";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { IOrganizacaoEmail } from "../../../Interfaces/Organizacao/Organizacao";

export default function InformacoesOrganizacao() {
    const {
        value: infoOrganizacao,
        loading: infoOrganizacaoLoading,
        execute: infoOrganizacaoExecute,
    } = useAsyncEffect(async () => {
        return getInfoOrganizacaoServiceController() ?? null;
    }, []);
    const [tabAtivado, setTabAtivado] = useState("infoGeral");
    const { execute: EditarInformacao, loading: EditarInformacaoLoading } =
        useAsyncCallback(EditarInformacaoController);

    function handleEditarInformacaoFormSubmit(formData: IOrganizacaoEmail) {
        if (infoOrganizacao != null) {
            const formDataValidade = {
                ...formData,
                FL_ENABLE_SSL_EMAIL:
                    String(formData.FL_ENABLE_SSL_EMAIL) === "true"
                        ? true
                        : false,
                FL_ENVIAR_EMAIL:
                    String(formData.FL_ENVIAR_EMAIL) === "true" ? true : false,
            };
            const formDataReturn = {
                ...infoOrganizacao,
                INFO_EMAIL: formDataValidade,
            };
            EditarInformacao(formDataReturn ?? {}).then(infoOrganizacaoExecute);
        }
    }

    const renderComponent = () => {
        switch (tabAtivado) {
            case "infoGeral":
                return <InfoGeral infoOrganizacao={infoOrganizacao} />;
            case "infoEndereco":
                return (
                    <InfoEndereco
                        infoEndereco={infoOrganizacao?.INFO_ENDERECO}
                    />
                );
            case "infoERP":
                return (
                    <InfoERP
                        infoERP={infoOrganizacao?.INFO_ERP}
                        infoGeral={infoOrganizacao}
                    />
                );
            case "infoEmail":
                return (
                    <InfoEmail
                        infoEmail={infoOrganizacao?.INFO_EMAIL}
                        handleEditarInformacaoFormSubmit={
                            handleEditarInformacaoFormSubmit
                        }
                        EditarInformacaoLoading={EditarInformacaoLoading}
                    />
                );
            default:
                return <NotFound />;
        }
    };

    return (
        <div className="subheader py-2 py-lg-6 subheader-transparent">
            <div className="container-fluid d-flex flex-wrap row m-0">
                <OrSpinner loading={infoOrganizacaoLoading} spinner="capys">
                    <Tab.Container
                        id="left-tabs-example"
                        defaultActiveKey="infoGeral"
                    >
                        <div className="col-11 col-md-5 col-lg-3 mb-5">
                            <InfoNavBar
                                setTabAtivado={setTabAtivado}
                                infoOrganizacao={infoOrganizacao}
                            />
                        </div>
                        <div className="col-13 col-md-11 col-lg-9 mb-5">
                            <div className="card card-custom h-100">
                                <div className="card-body">
                                    {renderComponent()}
                                </div>
                            </div>
                        </div>
                    </Tab.Container>
                </OrSpinner>
            </div>
        </div>
    );
}
